import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { MenuItem } from 'primeng/primeng';
import { BaseCrudComponent } from "../../base/base-crud.component";
import { Edicao } from '../../entity/edicao-model';
import { Participantes } from '../../entity/participantes';
import { ValidarData, ValidCpfORCnpj } from '../../util/custom.validators';
import { Situacoes } from '../../entity/enumeraveis';

@Component({
    selector: 'evento-prestacao-conta-crud',
    templateUrl: 'evento-prestacao-conta-crud.component.html'
})

export class CrudEventoPrestacaoContaComponent extends BaseCrudComponent {
    controllerName = 'eventoPrestacaoConta';
    listaInstrutorCargaHoraria: any[] = [];
    validateForm: any = false;
    edicao: Edicao = new Edicao;
    isValid: boolean = false;
    private steps: any = null;
    etapas: MenuItem[] = [];
    listaDiasSemana: any[] = [];
    listaPais: any[] = [];
    listaCidades: any[] = [];
    listaUf: any[] = [];
    isPrestarConta: number = 0;
    listaConteudoProgramaticoEvento: any[] = [];
    listaEventoInstrutores: any[] = [];
    listaParticipantes: any[] = [];
    participantes: Participantes = new Participantes;
    edicaoSelecionada: number = 0;
    linkSelecionado: string;
    stepObject: any;
    hoje = new Date();
    turmaDataValida = new Date();
    isHomologacao: boolean = false;
    dataPrazo: Date;
    desativarBotaoSalvar: boolean = false;

    setStepObject(obj: any) {
        this.stepObject = obj;
    }

    init() {
        this.toggleLoading(true);
        this.hoje = new Date(this.hoje.setDate(new Date().getDate() + 5));
        this.turmaDataValida = new Date(this.turmaDataValida.setDate(new Date().getDate() + 5))

        this.cadastro = this.formBuilder.group({
            etapa1: this.formBuilder.group({
                participantes: this.formBuilder.group({
                    nome: [null],
                    cpf: [null, ValidCpfORCnpj],
                    id_edicao: [null],
                    tipo_inclusao: [2]
                })

            }),
            etapa2: this.formBuilder.group({
                id_tipo_certificacao: [null, [Validators.required]],
                titulo: [null, [Validators.required, Validators.maxLength(255)]],
                data_inicio: [null, [Validators.required]],
                data_fim: [null, [Validators.required]],
                id_pais: [null, [Validators.required]],
                id_uf: [null],
                id_cidade: [null],
                id_evento: [],
                id: [null]
            }),
            etapa3: this.formBuilder.group({
                titulo: [null, [Validators.required, Validators.maxLength(255)]],
                data_inicio: [null, [Validators.required]],
                data_fim: [null, [Validators.required]],
                id_pais: [null, [Validators.required]],
                id_uf: [null],
                id_cidade: [null],
                id_tipo_certificacao: [null, [Validators.required]]
            }),
            etapa4: this.formBuilder.group({
                titulo: [null],
                data_inicio: [null],
                data_fim: [null],
                dia_semana: [null],
                id_pais: [null],
                id_uf: [null],
                id_cidade: [null],
                participantes: [null],
                id_tipo_certificacao: [null]
            }),
            etapa5: this.formBuilder.group({
                id: [null],
            }),
        });
        this.service.ListarTodos('uf').subscribe(data => {
            this.listaUf = data;
        });
        this.service.ListarTodos('combo/dia_semana').subscribe(data => {
            this.listaDiasSemana = data;
        });
        this.service.ListarTodos('pais').subscribe(data => {
            this.listaPais = data;
        });
        this.service.ListarTodos('cidade').subscribe(data => {
            this.listaCidades = data;
        });

        this.cadastro.get('etapa2.data_fim').valueChanges.subscribe(x => {
            let inicio = new Date(this.cadastro.get('etapa2.data_inicio').value);
            let fim = new Date(this.cadastro.get('etapa2.data_fim').value);
            if (!ValidarData(inicio, fim)) {
                this.cadastro.get('etapa2.data_fim').setErrors({ error: 'A data fim não pode ser menor que a data de início da turma.' });
                super.showMsg('warn', 'Turma', 'A data fim não pode ser menor que a data de início da turma.');
                return;
            }
        });

        var listaLink = location.href.split("/")
        var etapaSelecionada = listaLink[6];
        this.edicaoSelecionada = +listaLink[7]
        this.linkSelecionado = etapaSelecionada;

        switch (etapaSelecionada) {
            case "prestar-conta":
                this.etapas = [
                    { label: 'Prestar Conta' }
                ];
                this.etapa = 0;
                break;
            case "prestar-conta-homologacao":
                this.etapas = [
                    { label: 'Prestar Conta' }
                ];
                this.etapa = 0;
                break;
            case "editar":
                this.etapas = [
                    { label: 'Editar Edicao' }
                ];
                this.etapa = 1;
                break;
            case "editar-homologacao":
                this.etapas = [
                    { label: 'Editar Edicao' }
                ];
                this.etapa = 1;
                break;
            case "incluir-edicao":
                this.etapas = [
                    { label: 'Incluir Edicao' }
                ];
                this.etapa = 2;
                break;
            case "incluir-edicao-homologacao":
                this.etapas = [
                    { label: 'Incluir Edicao' }
                ];
                this.etapa = 2;
                break;
            case "edicao-visualizar":
                this.etapas = [
                    { label: 'Visualizar Edicao' }
                ];
                this.etapa = 3;
                break;
            case "edicao-visualizar-homologacao":
                this.etapas = [
                    { label: 'Visualizar Edicao' }
                ];
                this.etapa = 3;
                break;
            case "profissionais-pendentes":
                this.etapas = [
                    { label: 'Profissionais Pendentes' }
                ];
                this.etapa = 3;
                break;
            case "prestar-conta-individual":
                this.etapas = [
                    { label: 'Prestar Conta' }
                ];
                this.etapa = 4;
                break;
            case "prestar-conta-individual-homologacao":
                this.etapas = [
                    { label: 'Prestar Conta' }
                ];
                this.etapa = 4;
                break;
        }

        this.observableUser.getValue.subscribe(data => {
            if (data && data != "") {
                if (data.obj.lotacaoDTO.find(y => y.id == localStorage.getItem('lotacao')).sigla == 'CFC'
                  && data.obj.lotacaoDTO.find(y => y.id == localStorage.getItem('lotacao'))
                    .perfilDTO.filter(x => x.nome == 'Gestor CFC')
                    .length > 0) {
                    this.isHomologacao = true;
                }
                else {
                    this.isHomologacao = false;
                }
            }
        });
    }
    private toggleLoading(loading: boolean): void {
        this.observableUtilPanelDoc.setBlockedPanel(loading);
    }
    
    afterLoad() {
        if (this.etapa === 1) {
            this.cadastro.get('etapa2.id').setValue(this.obj.id);
            if (this.obj.id_uf !== null) {
                this.cadastro.get('etapa2.id_uf').setValue(this.obj.id_uf);
            }
            if (this.obj.id_cidade !== null) {
                this.cadastro.get('etapa2.id_cidade').setValue(this.obj.id_cidade);
            }

            this.cadastro.get('etapa2.id_pais').setValue(this.obj.id_pais);
            this.cadastro.get('etapa2.id_evento').setValue(this.obj.id_evento);
            this.cadastro.get('etapa2.titulo').setValue(this.obj.titulo);
            this.cadastro.get('etapa2.data_inicio').setValue(this.obj.data_inicio);
            this.cadastro.get('etapa2.data_fim').setValue(this.obj.data_fim);
            this.cadastro.get('etapa2.id_tipo_certificacao').setValue(this.obj.id_tipo_certificacao);
        }
        if (this.etapa === 0) {
            this.verificaCapacitadoraPodePrestarConta();
            this.listaConteudoProgramaticoEvento = this.obj[0].evento.conteudo_programatico_evento.map(item => {
                if (this.obj[0].justificar_evento.length > 0) {
                    item.justificar_evento = this.obj[0].justificar_evento.filter(valor => item.id == valor.id_conteudo_programatico_evento);
                }
                if (this.obj[0].prestar_contas_evento.length > 0) {
                    item.prestar_contas_evento = this.obj[0].prestar_contas_evento.filter(valor => item.id == valor.id_conteudo_programatico_evento);
                }
                item.evento = this.obj[0].evento;
                item.id_situacao = this.obj[0].id_situacao;
                return item;
            });

            this.listaEventoInstrutores = this.obj[0].evento.evento_instrutor.map(item => {
                return item.instrutor;
            });

            this.listaParticipantes = this.obj[0].participantes_evento;
            
        }
        if (this.etapa === 3) {
            this.cadastro.get('etapa4.titulo').setValue(this.obj[0].titulo);
            this.cadastro.get('etapa4.data_inicio').setValue(this.obj[0].data_inicio);
            this.cadastro.get('etapa4.data_fim').setValue(this.obj[0].data_fim);
            this.cadastro.get('etapa4.id_pais').setValue(this.obj[0].id_pais);
            this.cadastro.get('etapa4.id_uf').setValue(this.obj[0].id_uf);
            this.cadastro.get('etapa4.id_cidade').setValue(this.obj[0].id_cidade);
            this.cadastro.get('etapa4.participantes').setValue(this.obj[0].participantes_evento);
            this.cadastro.get('etapa4.id_tipo_certificacao').setValue(this.obj[0].id_tipo_certificacao);
        }
        if (this.etapa === 4) {
            this.listaConteudoProgramaticoEvento = this.obj[0].evento.conteudo_programatico_evento.map(item => {
                if (this.obj[0].justificar_evento.length > 0) { item.justificar_evento = this.obj[0].justificar_evento.filter(valor => item.id == valor.id_conteudo_programatico_evento); }
                if (this.obj[0].prestar_contas_evento.length > 0) { item.prestar_contas_evento = this.obj[0].prestar_contas_evento.filter(valor => item.id == valor.id_conteudo_programatico_evento); }
                item.evento = this.obj[0].evento;
                item.id_situacao = this.obj[0].id_situacao;
                item.participantes_individual = this.obj[0].participantes_individual;
                return item;
            });
            this.listaEventoInstrutores = this.obj[0].evento.evento_instrutor.map(item => {
                return item.instrutor;
            });
            this.listaParticipantes = this.obj[0].participantes_evento;
            this.desativarBotaoSalvar = true;
        }
        this.toggleLoading(false);
    }

    verificaCapacitadoraPodePrestarConta() {
        let permitePrazo: any;
        this.service
          .Obter("edicaoEvento/verificarPrazoPorId/", this.obj[0].id)
          .subscribe((item) => {
              this.observableUtilPanelDoc.setBlockedPanel(false);
              permitePrazo = item;
          });
        const dataFim = new Date(this.obj[0].data_fim);
        const anoEdicao = dataFim.getFullYear();

        this.service.obterPrazoPrestacao(anoEdicao).subscribe((prazo: string) => {
            this.dataPrazo = new Date(prazo);
            if (this.ehCapacitadora && new Date(new Date().setHours(0, 0, 0, 0)) > this.dataPrazo){
                return this.showMsgWarn(`A data limite para prestar contas das edições de ${anoEdicao} é ${this.dataPrazo.toLocaleDateString()}`);
            }
            else if (this.ehCapacitadora && permitePrazo.prazoCapacitadoraAcabou) {
                this.showMsgWarn(`A data limite para prestar contas das edições de ${anoEdicao} é ${this.dataPrazo.toLocaleDateString()}`);
                return this.voltar(null, this.etapa);
            }
        })

    }

    voltar(event: any, etapa: number) {
        if (etapa === 2) {
            if (this.linkSelecionado === 'incluir-edicao-homologacao') {
                this.router.navigate(['/atividades/homologacao-evento'], { relativeTo: this.activatedRoute });
            } else {
                this.router.navigate(['/atividades/gerenciamento-evento'], { relativeTo: this.activatedRoute });
            }
        }
        else {
            var hmg = this.linkSelecionado.split('-');
            var individual = hmg[2] === 'individual';
            if (individual) {
                if (hmg.length === 4) {
                    this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao-homologacao', this.obj[0].id_evento], { relativeTo: this.activatedRoute });
                } else {
                    this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao', this.obj[0].id_evento], { relativeTo: this.activatedRoute });
                }
            } else {
                if ((hmg.length === 3)) {
                    this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao-homologacao', this.obj[0].id_evento], { relativeTo: this.activatedRoute });
                } else if (hmg[1] == 'homologacao'){
                    this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao-homologacao', this.obj.id_evento], { relativeTo: this.activatedRoute });    
                }
                else {
                    this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao', this.obj.id_evento], { relativeTo: this.activatedRoute });
                    
                }
            }
        }
    }

    validarData(): boolean {

        let inicio = new Date(this.cadastro.get('etapa3.data_inicio').value);
        let final = new Date(this.cadastro.get('etapa3.data_fim').value);

        if (final < inicio)
            return false;
        else
            return true;
    }
    finalizar(event: any, etapa: number) {
        let id_situacao = 0;
        switch (etapa) {
            case 0:
                this.listaParticipantes = this.listaParticipantes.map(item => {
                    item.id_edicao_evento = this.edicaoSelecionada;
                    item.id = item.id || 0;
                    item.edicao_evento = null;
                    item.cpf = this.limpaCaracterEspecial(item.cpf);
                    return item;
                });
                break;
            case 1:
                if (this.cadastro.get('etapa2').valid) {
                    let inicio = new Date(this.cadastro.get('etapa2.data_inicio').value);
                    let fim = new Date(this.cadastro.get('etapa2.data_fim').value);
                    if (!ValidarData(inicio, fim)) {
                        this.cadastro.get('etapa2.data_fim').setErrors({ error: 'A data fim não pode ser menor que a data de início da turma.' });
                        super.showMsg('warn', 'Turma', 'A data fim não pode ser menor que a data de início da turma.');
                        return;
                    }
                    this.edicao.id = this.cadastro.get('etapa2.id').value;
                    this.edicao.id_uf = this.cadastro.get('etapa2.id_uf').value;
                    this.edicao.id_pais = this.cadastro.get('etapa2.id_pais').value;
                    this.edicao.id_cidade = this.cadastro.get('etapa2.id_cidade').value;
                    this.edicao.id_evento = this.cadastro.get('etapa2.id_evento').value;
                    this.edicao.titulo = this.cadastro.get('etapa2.titulo').value;
                    this.edicao.data_inicio = this.cadastro.get('etapa2.data_inicio').value;
                    this.edicao.data_fim = this.cadastro.get('etapa2.data_fim').value;
                    this.edicao.id_tipo_certificacao = this.cadastro.get('etapa2.id_tipo_certificacao').value;
                }
                else {
                    this.touchAll(this.cadastro);
                    return;
                }
                break;
            case 2:
                if (this.cadastro.get('etapa3').valid) {
                    let inicio = new Date(this.cadastro.get('etapa3.data_inicio').value);
                    // if (inicio < this.hoje && !this.isHomologacao) {
                    //     super.showMsg('warn', 'Edicao', 'A data de início preenchida deve ser de, pelo menos, 5 dias após a data atual.');
                    //     return;
                    // }
                    if (!this.validarData()) {
                        super.showMsg('warn', 'Edicao', 'A data fim não pode ser menor que a data de início do evento.');
                        return;
                    }
                    this.edicao.id = null;
                    this.edicao.id_uf = this.cadastro.get('etapa3.id_uf').value;
                    this.edicao.id_pais = this.cadastro.get('etapa3.id_pais').value;
                    this.edicao.id_cidade = this.cadastro.get('etapa3.id_cidade').value;
                    this.edicao.id_evento = this.edicaoSelecionada
                    this.edicao.titulo = this.cadastro.get('etapa3.titulo').value;
                    this.edicao.data_inicio = this.cadastro.get('etapa3.data_inicio').value;
                    this.edicao.data_fim = this.cadastro.get('etapa3.data_fim').value;
                    this.edicao.id_tipo_certificacao = this.cadastro.get('etapa3.id_tipo_certificacao').value;
                    this.edicao.id_situacao = Situacoes.Agendada;
                }
                else {
                    this.touchAll(this.cadastro);
                    return;
                }
                break;
        }
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, a Prestação de Contas do Evento será
             ${this.acao == 'cadastrar' ? 'salva' : 'atualizada'} na base de dados.
            Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                switch (etapa) {
                    case 0:
                        id_situacao = Situacoes.Concluído;
                        this.service.Atualizar('edicaoEvento', { id: this.edicaoSelecionada, id_situacao }, { parcial: "id_situacao" }).subscribe();

                        this.service.Adicionar('participantesEvento/salvarLista', this.listaParticipantes).subscribe(sucess => {
                              this.showMsgSucess('Registro salvo com sucesso.');
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                              if (this.linkSelecionado === 'prestar-conta-homologacao') {
                                  this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao-homologacao', this.obj[0].id_evento], { relativeTo: this.activatedRoute });
                              } else {
                                  this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao', this.obj[0].id_evento], { relativeTo: this.activatedRoute });
                              }
                          },
                          err => {
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                              super.showMsgWarn(`Erro ao atualizar. ${err._body}`)
                          }
                        );
                        break;
                    case 1:
                        this.service.Atualizar('edicaoEvento', this.edicao).subscribe(sucess => {
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                              if (this.linkSelecionado === 'editar-homologacao') {
                                  this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao-homologacao', this.obj.id_evento], { relativeTo: this.activatedRoute });
                              } else {
                                  this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao', this.obj.id_evento], { relativeTo: this.activatedRoute });
                              }
                              super.showMsgSucess('Registro salvo com sucesso.');
                          },
                          err => {
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                              this.showMsgError(`Erro ao gravar. ${err._body}`)
                          })

                        break;
                    case 2:

                        this.service.Adicionar("edicaoEvento/verificarPrazo/", this.edicao).subscribe(
                          item => {
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                              if (item.prazoProfissionalAcabou && !this.ehGestorEpc) {
                                  if (!item.profissionalPrazoExtra) {
                                      this.showMsgWarn(`O prazo para envio das atividades do exercício de ${item.exercicio} está finalizado.`);
                                      return;
                                  }
                              }
                              this.service.Adicionar('edicaoEvento', this.edicao).subscribe(sucess => {
                                    if (this.linkSelecionado === 'incluir-edicao-homologacao') {
                                        this.router.navigate(['/atividades/homologacao-evento'], { relativeTo: this.activatedRoute });
                                    } else {
                                        this.router.navigate(['/atividades/gerenciamento-evento'], { relativeTo: this.activatedRoute });
                                    }
                                    super.showMsgSucess('Registro salvo com sucesso.');
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                },
                                err => {
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsgError(`Erro ao gravar. ${err._body}`)
                                })
                          }, err => {
                              super.showMsg('error', 'Mensagem de Erro', `Houve um erro ao verificar o prazo do registro.<br> ${err._body}`)
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                          });
                        break;
                    case 4:
                        id_situacao = Situacoes.Concluído;
                        this.service.Atualizar('edicaoEvento', { id: this.edicaoSelecionada, id_situacao }, { parcial: "id_situacao" }).subscribe(sucess => {
                              if (this.linkSelecionado === 'prestar-conta-individual-homologacao') {
                                  this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao-homologacao', this.obj[0].id_evento], { relativeTo: this.activatedRoute });
                              } else {
                                  this.router.navigate(['/atividades/evento-prestacao-conta/listar-edicao', this.obj[0].id_evento], { relativeTo: this.activatedRoute });
                              }
                              super.showMsgSucess('Registro salvo com sucesso.');
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                          },
                          err => {
                              this.observableUtilPanelDoc.setBlockedPanel(false);
                              this.showMsgError(`Erro ao gravar. ${err._body}`)
                          })
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/evento-prestacao-conta/crud/evento-prestacao-conta-crud.component.ts